import { useFormik } from 'formik';
import { initialValues } from './formData';
import { ParamWithNestedParent } from '../../../../../shared/types/param';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';

export const useSubmotive4Filters = (
    onFilter?: (data: ParamWithNestedParent) => void
) => {
    const [motives, setMotives] = useState<ISelect[]>([]);
    const [submotives1, setSubmotives1] = useState<ISelect[]>([]);
    const [submotives2, setSubmotives2] = useState<ISelect[]>([]);
    const [submotives3, setSubmotives3] = useState<ISelect[]>([]);
    const [types, setTypes] = useState<ISelect[]>([]);
    const onSubmit = (data: ParamWithNestedParent) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_MOTIVE).then((params) =>
            setMotives(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE1).then((params) =>
            setSubmotives1(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE2).then((params) =>
            setSubmotives2(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE3).then((params) =>
            setSubmotives3(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) =>
            setTypes(params.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    return {
        formik,
        motives,
        submotives1,
        submotives2,
        submotives3,
        types,
    };
};
